export const lists_awards = [
    {
        "id": 0,
        "naam": "Prullenbakken geblust",
        "brons": 10,
        "zilver": 200,
        "goud": 4000,
        "type": "Doorlopend"
    },
    {
        "id": 1,
        "naam": "Vaste speler",
        "brons": 30,
        "zilver": 180,
        "goud": 365,
        "type": "Doorlopend"
    },
    {
        "id": 2,
        "naam": "Levens gered",
        "brons": 200,
        "zilver": 10000,
        "goud": 100000,
        "type": "Doorlopend"
    },
    {
        "id": 3,
        "naam": "Super snel blussen",
        "brons": 200,
        "zilver": 10000,
        "goud": 100000,
        "type": "Doorlopend"
    },
    {
        "id": 4,
        "naam": "Forum-Junkie",
        "brons": 30,
        "zilver": 200,
        "goud": 10000,
        "type": "Doorlopend"
    },
    {
        "id": 5,
        "naam": "Chat-Junkie",
        "brons": 100,
        "zilver": 1000,
        "goud": 50000,
        "type": "Doorlopend"
    },
    {
        "id": 6,
        "naam": "Paasei-Vinder",
        "brons": 10,
        "zilver": 100,
        "goud": 5000,
        "type": "Doorlopend"
    },
    {
        "id": 9,
        "naam": "Griezelige meldingen",
        "brons": 1,
        "zilver": 30,
        "goud": 100,
        "type": "Doorlopend"
    },
    {
        "id": 10,
        "naam": "Kerstfeest gered!",
        "brons": 10,
        "zilver": 200,
        "goud": 1000,
        "type": "Doorlopend"
    },
    {
        "id": 11,
        "naam": "Stevig vuurwerk",
        "brons": 5,
        "zilver": 30,
        "goud": 200,
        "type": "Doorlopend"
    },
    {
        "id": 17,
        "naam": "Sinterklaasfeest gered",
        "brons": 1,
        "zilver": 50,
        "goud": 150,
        "type": "Doorlopend"
    },
    {
        "id": 19,
        "naam": "Paashaas missies",
        "brons": 10,
        "zilver": 200,
        "goud": 2000,
        "type": "Doorlopend"
    },
    {
        "id": 20,
        "naam": "Pompoenenjager",
        "brons": 10,
        "zilver": 200,
        "goud": 2000,
        "type": "Doorlopend"
    },
    {
        "id": 21,
        "naam": "Valentijnsdag",
        "brons": 1,
        "zilver": 30,
        "goud": 100,
        "type": "Doorlopend"
    },
    {
        "id": 23,
        "naam": "Moederdag Inzetten",
        "brons": 5,
        "zilver": 100,
        "goud": 1000,
        "type": "Doorlopend"
    },
    {
        "id": 24,
        "naam": "Europees kampioenschap Voetbal 2021 - Award",
        "brons": 10,
        "zilver": 50,
        "goud": 200,
        "type": "Eenmalig"
    },
    {
        "id": 25,
        "naam": "Zomerevenement-award",
        "brons": 10,
        "zilver": 400,
        "goud": 2000,
        "type": "Doorlopend"
    },
    {
        "id": 26,
        "naam": "Herfstevenement",
        "brons": 10,
        "zilver": 100,
        "goud": 1000,
        "type": "Doorlopend"
    },
    {
        "id": 27,
        "naam": "Europese 112-dag",
        "brons": 5,
        "zilver": 15,
        "goud": 50,
        "type": "Doorlopend"
    },
    {
        "id": 29,
        "naam": "Carnaval",
        "brons": 5,
        "zilver": 15,
        "goud": 50,
        "type": "Doorlopend"
    },
    {
        "id": 30,
        "naam": "Missies Lente-evenement",
        "brons": 10,
        "zilver": 100,
        "goud": 1000,
        "type": "Doorlopend"
    },
    {
        "id": 31,
        "naam": "Race Event",
        "brons": 5,
        "zilver": 15,
        "goud": 50,
        "type": "Doorlopend"
    },
    {
        "id": 32,
        "naam": "Wereldkampioenschap voetbal 2022 - Award",
        "brons": 5,
        "zilver": 15,
        "goud": 50,
        "type": "Eenmalig"
    },
    {
        "id": 33,
        "naam": "Kerstmis 2022",
        "brons": 5,
        "zilver": 15,
        "goud": 50,
        "type": "Eenmalig"
    },
    {
        "id": 34,
        "naam": "Winter Event 2023",
        "brons": 10,
        "zilver": 400,
        "goud": 1000,
        "type": "Eenmalig"
    },
    {
        "id": 35,
        "naam": "Nieuw Jaar 2022",
        "brons": 5,
        "zilver": 30,
        "goud": 200,
        "type": "Eenmalig"
    },
    {
        "id": 36,
        "naam": "Valentijnsdag 2023",
        "brons": 1,
        "zilver": 30,
        "goud": 100,
        "type": "Eenmalig"
    },
    {
        "id": 37,
        "naam": "Romanticus",
        "brons": 50,
        "zilver": 300,
        "goud": 2000,
        "type": "Doorlopend"
    },
    {
        "id": 38,
        "naam": "7 Jarig Jubileum!",
        "brons": 5,
        "zilver": 15,
        "goud": 50,
        "type": "Eenmalig"
    },
    {
        "id": 39,
        "naam": "Europese 112-dag 2023",
        "brons": 5,
        "zilver": 30,
        "goud": 100,
        "type": "Eenmalig"
    },
    {
        "id": 40,
        "naam": "Carnaval 2023",
        "brons": 5,
        "zilver": 15,
        "goud": 50,
        "type": "Eenmalig"
    },
    {
        "id": 41,
        "naam": "Lente-evenement 2023",
        "brons": 10,
        "zilver": 400,
        "goud": 1000,
        "type": "Eenmalig"
    },
    {
        "id": 42,
        "naam": "Paasei-vinder 2023",
        "brons": 10,
        "zilver": 250,
        "goud": 750,
        "type": "Eenmalig"
    },
    {
        "id": 43,
        "naam": "Paashaas missies 2023",
        "brons": 10,
        "zilver": 200,
        "goud": 500,
        "type": "Eenmalig"
    },
    {
        "id": 44,
        "naam": "Moederdag Inzetten 2023",
        "brons": 5,
        "zilver": 50,
        "goud": 100,
        "type": "Eenmalig"
    },
    {
        "id": 45,
        "naam": "Vaderdag 2023",
        "brons": 5,
        "zilver": 50,
        "goud": 100,
        "type": "Eenmalig"
    },
    {
        "id": 46,
        "naam": "Zomer Event 2023",
        "brons": 25,
        "zilver": 300,
        "goud": 1000,
        "type": "Eenmalig"
    },
    {
        "id": 47,
        "naam": "Voetbal Event 2023",
        "brons": 100,
        "zilver": 200,
        "goud": 400,
        "type": "Eenmalig"
    },
    {
        "id": 48,
        "naam": "Race Event 2023",
        "brons": 25,
        "zilver": 50,
        "goud": 100,
        "type": "Eenmalig"
    },
    {
        "id": 49,
        "naam": "Zonnebloem enthousiast 2023",
        "brons": 10,
        "zilver": 250,
        "goud": 500,
        "type": "Eenmalig"
    },
    {
        "id": 50,
        "naam": "Verband Uitdaging 2023",
        "brons": 10,
        "zilver": 50,
        "goud": 200,
        "type": "Eenmalig"
    },
    {
        "id": 51,
        "naam": "Herfstevenement 2023",
        "brons": 10,
        "zilver": 100,
        "goud": 1000,
        "type": "Eenmalig"
    },
    {
        "id": 52,
        "naam": "Trouwe Supporter",
        "brons": "",
        "zilver": "",
        "goud": "Een speciale award voor onze oudste supporters. Toegekend aan spelers die voor 2 oktober 2023 een Premium Account hebben gekocht.",
        "type": "Eenmalig"
    },
    {
        "id": 53,
        "naam": "1-Maand VIP",
        "brons": "",
        "zilver": "",
        "goud": "Premium account lid voor 1 maand.",
        "type": "Doorlopend"
    },
    {
        "id": 54,
        "naam": "3-Maanden VIP",
        "brons": "",
        "zilver": "",
        "goud": "Premium account lid voor 3 maanden.",
        "type": "Doorlopend"
    },
    {
        "id": 55,
        "naam": "6-Maanden VIP",
        "brons": "",
        "zilver": "",
        "goud": "Premium account lid voor 6 maanden.",
        "type": "Doorlopend"
    },
    {
        "id": 56,
        "naam": "1-Jaar VIP",
        "brons": "",
        "zilver": "",
        "goud": "Premium account lid voor 1 jaar",
        "type": "Doorlopend"
    },
    {
        "id": 57,
        "naam": "2-Jaren VIP",
        "brons": "",
        "zilver": "",
        "goud": "Premium account lid voor 2 jaar",
        "type": "Doorlopend"
    },
    {
        "id": 58,
        "naam": "3-Jaren VIP",
        "brons": "",
        "zilver": "",
        "goud": "Premium account lid voor 3 jaar",
        "type": "Doorlopend"
    },
    {
        "id": 59,
        "naam": "4-Jaren VIP",
        "brons": "",
        "zilver": "",
        "goud": "Premium account lid voor 4 jaar",
        "type": "Doorlopend"
    },
    {
        "id": 60,
        "naam": "5-Jaren VIP",
        "brons": "",
        "zilver": "",
        "goud": "Premium account lid voor 5 jaar",
        "type": "Doorlopend"
    },
    {
        "id": 61,
        "naam": "6-Jaren VIP",
        "brons": "",
        "zilver": "",
        "goud": "Premium account lid voor 6 jaar",
        "type": "Doorlopend"
    },
    {
        "id": 62,
        "naam": "7-Jaren VIP",
        "brons": "",
        "zilver": "",
        "goud": "Premium account lid voor 7 jaar",
        "type": "Doorlopend"
    },
    {
        "id": 63,
        "naam": "8-Jaren VIP",
        "brons": "",
        "zilver": "",
        "goud": "Premium account lid voor 8 jaar",
        "type": "Doorlopend"
    },
    {
        "id": 64,
        "naam": "9-Jaren VIP",
        "brons": "",
        "zilver": "",
        "goud": "Premium account lid voor 9 jaar",
        "type": "Doorlopend"
    },
    {
        "id": 65,
        "naam": "10-Jaren VIP",
        "brons": "",
        "zilver": "",
        "goud": "Premium account lid voor 10 jaar",
        "type": "Doorlopend"
    },
    {
        "id": 66,
        "naam": "11-Jaren VIP",
        "brons": "",
        "zilver": "",
        "goud": "Premium account lid voor 11 jaar",
        "type": "Doorlopend"
    },
    {
        "id": 67,
        "naam": "12-Jaren VIP",
        "brons": "",
        "zilver": "",
        "goud": "Premium account lid voor 12 jaar",
        "type": "Doorlopend"
    },
    {
        "id": 68,
        "naam": "13-Jaren VIP",
        "brons": "",
        "zilver": "",
        "goud": "Premium account lid voor 13 jaar",
        "type": "Doorlopend"
    },
    {
        "id": 69,
        "naam": "14-Jaren VIP",
        "brons": "",
        "zilver": "",
        "goud": "Premium account lid voor 14 jaar",
        "type": "Doorlopend"
    },
    {
        "id": 70,
        "naam": "15-Jaren VIP",
        "brons": "",
        "zilver": "",
        "goud": "Premium account lid voor 15 jaar",
        "type": "Doorlopend"
    },
    {
        "id": 71,
        "naam": "16-Jaren VIP",
        "brons": "",
        "zilver": "",
        "goud": "Premium account lid voor 16 jaar",
        "type": "Doorlopend"
    },
    {
        "id": 72,
        "naam": "17-Jaren VIP",
        "brons": "",
        "zilver": "",
        "goud": "Premium account lid voor 17 jaar",
        "type": "Doorlopend"
    },
    {
        "id": 73,
        "naam": "18-Jaren VIP",
        "brons": "",
        "zilver": "",
        "goud": "Premium account lid voor 18 jaar",
        "type": "Doorlopend"
    },
    {
        "id": 74,
        "naam": "19-Jaren VIP",
        "brons": "",
        "zilver": "",
        "goud": "Premium account lid voor 19 jaar",
        "type": "Doorlopend"
    },
    {
        "id": 75,
        "naam": "20-Jaren VIP",
        "brons": "",
        "zilver": "",
        "goud": "Premium account lid voor 20 jaar",
        "type": "Doorlopend"
    },
    {
        "id": 76,
        "naam": "Halloween 2023",
        "brons": 15,
        "zilver": 150,
        "goud": 300,
        "type": "Eenmalig"
    },
    {
        "id": 77,
        "naam": "Pompoenenjager 2023",
        "brons": 10,
        "zilver": 250,
        "goud": 500,
        "type": "Eenmalig"
    },
    {
        "id": 78,
        "naam": "Sinterklaas Award 2023",
        "brons": 10,
        "zilver": 50,
        "goud": 100,
        "type": "Eenmalig"
    },
    {
        "id": 79,
        "naam": "Snoep verzameld",
        "brons": 10,
        "zilver": 25,
        "goud": 50,
        "type": "Eenmalig"
    },
    {
        "id": 80,
        "naam": "Kerstmis 2023",
        "brons": 15,
        "zilver": 150,
        "goud": 250,
        "type": "Eenmalig"
    },
    {
        "id": 81,
        "naam": "Kerstverzamelaar 2023",
        "brons": 10,
        "zilver": 250,
        "goud": 500,
        "type": "Eenmalig"
    },
    {
        "id": 82,
        "naam": "Nieuw Jaar 2023",
        "brons": 5,
        "zilver": 15,
        "goud": 50,
        "type": "Eenmalig"
    },
    {
        "id": 83,
        "naam": "Winter Event 2024",
        "brons": 10,
        "zilver": 400,
        "goud": 1000,
        "type": "Eenmalig"
    },
    {
        "id": 84,
        "naam": "Team Uitdaging Januari 2024",
        "brons": 5,
        "zilver": 15,
        "goud": 50,
        "type": "Eenmalig"
    },
    {
        "id": 85,
        "naam": "Valentijnsdag 2024",
        "brons": 5,
        "zilver": 30,
        "goud": 100,
        "type": "Eenmalig"
    },
    {
        "id": 86,
        "naam": "Romanticus 2024",
        "brons": 10,
        "zilver": 200,
        "goud": 400,
        "type": "Eenmalig"
    },
    {
        "id": 87,
        "naam": "Europese 112-dag 2024",
        "brons": 5,
        "zilver": 15,
        "goud": 50,
        "type": "Eenmalig"
    },
    {
        "id": 88,
        "naam": "Carnaval 2024",
        "brons": 5,
        "zilver": 15,
        "goud": 50,
        "type": "Eenmalig"
    },
    {
        "id": 89,
        "naam": "8 Jarig Jubileum!",
        "brons": 5,
        "zilver": 15,
        "goud": 50,
        "type": "Eenmalig"
    },
    {
        "id": 90,
        "naam": "Politie Uitdaging Februari 2024",
        "brons": 10,
        "zilver": 50,
        "goud": 200,
        "type": "Eenmalig"
    },
    {
        "id": 91,
        "naam": "Team Uitdaging Maart 2024",
        "brons": 5,
        "zilver": 15,
        "goud": 50,
        "type": "Eenmalig"
    },
    {
        "id": 92,
        "naam": "Paasei-vinder 2024",
        "brons": 10,
        "zilver": 100,
        "goud": 300,
        "type": "Eenmalig"
    },
    {
        "id": 93,
        "naam": "Paashaas missies 2024",
        "brons": 5,
        "zilver": 30,
        "goud": 75,
        "type": "Eenmalig"
    },
    {
        "id": 94,
        "naam": "Lente-evenement 2024",
        "brons": 10,
        "zilver": 100,
        "goud": 500,
        "type": "Eenmalig"
    },
    {
        "id": 95,
        "naam": "Alliantie Uitdaging April 2024",
        "brons": 5,
        "zilver": 15,
        "goud": 50,
        "type": "Eenmalig"
    },
    {
        "id": 96,
        "naam": "Moederdag Inzetten 2024",
        "brons": 5,
        "zilver": 50,
        "goud": 100,
        "type": "Eenmalig"
    },
    {
        "id": 97,
        "naam": "Alliantie Uitdaging Mei 2024",
        "brons": 5,
        "zilver": 15,
        "goud": 50,
        "type": "Eenmalig"
    },
    {
        "id": 98,
        "naam": "Vaderdag 2024",
        "brons": 5,
        "zilver": 50,
        "goud": 100,
        "type": "Eenmalig"
    },
    // geen id bekend
    {
        "naam": "1 April 2016",
        "brons": "",
        "zilver": "",
        "goud": "Je hebt deelgenomen aan het event.",
        "type": "Eenmalig"
    },
    {
        "naam": "1.000 Facebook likes",
        "brons": "",
        "zilver": "",
        "goud": "Je hebt deelgenomen aan het event.",
        "type": "Eenmalig"
    },
    {
        "naam": "112 ON WHEELS",
        "brons": "",
        "zilver": "",
        "goud": "Aanwezig geweest bij 112 on wheels 2017.",
        "type": "Eenmalig"
    },
    {
        "naam": "Landelijke Veiligheidsdag",
        "brons": "",
        "zilver": "",
        "goud": "Deelgenomen aan veiligheidsdag event 2019.",
        "type": "Eenmalig"
    },
    {
        "naam": "5 Jarig Jubileum!",
        "brons": 5,
        "zilver": 15,
        "goud": 50,
        "type": "Eenmalig"
    },
    {
        "naam": "6 Jarig Jubileum!",
        "brons": 5,
        "zilver": 15,
        "goud": 50,
        "type": "Eenmalig"
    },
]
